var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 27,
    viewBox: "0 0 12 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3131_13196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4785 1.17586C6.4806 5.93499 7.70385 9.81211 9.2106 12.0749V25.0345C9.2106 25.4046 9.5151 25.7091 9.88523 25.7091H10.4916C10.8617 25.7091 11.1662 25.4046 11.1662 25.0345V1.42524C11.1662 1.06036 10.7121 0.897612 10.4785 1.17586Z",
    fill: "#050033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42026 1.80844C5.17875 1.84781 5.01338 2.07356 5.01338 2.31769V8.19769C5.01338 8.52581 4.74826 8.79094 4.42013 8.79094C4.09201 8.79094 3.82688 8.52581 3.82688 8.19769V2.31769C3.82688 2.07356 3.6615 1.84781 3.42 1.80844C3.11288 1.75856 2.84775 1.99481 2.84775 2.29144V8.19769C2.84775 8.52581 2.58263 8.79094 2.2545 8.79094C1.92638 8.79094 1.66125 8.52581 1.66125 8.19769V2.31769C1.66125 2.07356 1.49588 1.84781 1.25438 1.80844C0.947254 1.75856 0.682129 1.99481 0.682129 2.29144V9.34481C0.682129 10.4657 1.37775 11.4238 2.3595 11.8123V25.0344C2.3595 25.4046 2.664 25.7091 3.03413 25.7091H3.6405C4.01063 25.7091 4.31513 25.4046 4.31513 25.0344V11.8123C5.29688 11.4212 5.99251 10.4657 5.99251 9.34481V2.29144C5.99251 1.99481 5.72738 1.75856 5.42026 1.80844Z",
    fill: "#050033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3131_13196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9375,
    height: 26.25,
    fill: "white",
    transform: "translate(0.46875 0.34375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDining);
export default __webpack_public_path__ + "static/media/dining.e602e36c1f482ff3005a30fcb86e3078.svg";
export { ForwardRef as ReactComponent };